import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL || 'https://api.nayabajar.com/graphql/',
  credentials: 'include', // Required for session authentication
});

/** Read a named cookie from document.cookie */
function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()!.split(';').shift() ?? null;
  }
  return null;
}

const authLink = setContext((_, { headers }) => {
  // Attach Django's CSRF token on every request so mutations work if
  // csrf_exempt is ever removed from the GraphQL endpoint.
  const csrfToken = getCookie('csrftoken');
  return {
    headers: {
      ...headers,
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

export const client = new ApolloClient({
  link: from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache({
    typePolicies: {
      // Graphene sends choice fields as enum names ('ACTIVE'); pages compare against 'active'
      AdType: {
        fields: {
          status: { read: (status) => (typeof status === 'string' ? status.toLowerCase() : status) },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
});
